/**
 * AdminRoute - Защита роутов для администраторов
 * 
 * Проверяет:
 * 1. Авторизован ли пользователь
 * 2. Имеет ли роль 'admin'
 * 
 * Если нет - редиректит на главную или страницу логина
 */

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAccessCheck } from './useAccessCheck';
import AccessCheckError from './AccessCheckError';
import PortalLoginRedirect from './PortalLoginRedirect';

interface AdminRouteProps {
  children: React.ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { user, loading, error, retry } = useAccessCheck();

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '50vh',
        color: '#8b949e'
      }}>
        Проверка доступа...
      </div>
    );
  }

  if (error) return <AccessCheckError message={error} onRetry={retry} />;

  // Не авторизован — на вход портала с возвратом на эту страницу
  if (!user) return <PortalLoginRedirect />;

  // Не админ - на главную с сообщением
  if (user.role !== 'admin') {
    return <Navigate to="/" state={{ error: 'Доступ запрещён. Требуются права администратора.' }} replace />;
  }

  // Админ - показываем контент
  return <>{children}</>;
};

export default AdminRoute;
